/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestResponse } from '../model';
import { environment } from '../../environments/environment';
import { ApiHeaders } from './headers';
import {BoardColumn} from "../model/board";

@Injectable()
export class BoardColumnProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getBoardColumn(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/board/${id}`, ApiHeaders.getOptions());
  }

  saveBoardColumn(boardId: string, column: BoardColumn): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/${boardId}/columns`, column, ApiHeaders.getOptions());
  }

  reorderColumn(id: string, column: BoardColumn, targetColumn: BoardColumn): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/${id}/columns/reorder`, {
        COLUMN: column.ID,
        TARGET_COLUMN: targetColumn.ID
      },
        ApiHeaders.getOptions());
  }

  deleteBoardColumn(id: string, columnId: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/${id}/columns/${columnId}/delete`, null, ApiHeaders.getOptions());
  }

  saveBoardColumnStage(boardId: string, columnId: string, stageId: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/${boardId}/columns/${columnId}/stage`, stageId, ApiHeaders.getOptions());
  }

}
